// extracted by mini-css-extract-plugin
export default {"body":"Fnance_body__gEh3Q","left-column":"Fnance_left-column__jvioj","right-column":"Fnance_right-column__ZHIcj","button":"Fnance_button__AXWrr"};